const geolocationFilters = {
  cities: '',
  areas: '',
  districts: '',
  streets: '',
  house_numbers: '',
  origin_longitude: '',
  longitude_delta: '',
  origin_latitude: '',
  latitude_delta: '',
};

export const getDefaultVideoAnalyticsFilters = (isServiceEnabled = true) => (
  {
    videoAnalytics: {
      bag: {
        isEnabled: isServiceEnabled,
        filters: {
          stream_ids: null,
          ...geolocationFilters,
        },
      },
      facecover: {
        isEnabled: isServiceEnabled,
        filters: {
          'event^facecover_score__gte:integer': '',
          'event^niqab_score__gte:integer': '',
          'event^balaclava_score__gte:integer': '',
          'event^other_score__gte:integer': '',
          stream_ids: null,
          ...geolocationFilters,
        },
      },
      crowd: {
        isEnabled: isServiceEnabled,
        filters: {
          'event^people_count__gte:integer': '',
          stream_ids: null,
          ...geolocationFilters,
        },
      },
      fight: {
        isEnabled: isServiceEnabled,
        filters: {
          'event^fight_score__gte:numeric': '',
          stream_ids: null,
          ...geolocationFilters,
        },
      },
      weapon: {
        isEnabled: isServiceEnabled,
        filters: {
          'event^weapon_score__gte:numeric': '',
          stream_ids: null,
          ...geolocationFilters,
        },
      },
      fire: {
        isEnabled: isServiceEnabled,
        filters: {
          'event^fire_score__gte:numeric': '',
          stream_ids: null,
          ...geolocationFilters,
        },
      },
      lying: {
        isEnabled: isServiceEnabled,
        filters: {
          'event^lying_score__gte:numeric': '',
          stream_ids: null,
          ...geolocationFilters,
        },
      },
      handsup: {
        isEnabled: isServiceEnabled,
        filters: {
          'event^handsup_score__gte:numeric': '',
          stream_ids: null,
          ...geolocationFilters,
        },
      },
      fall: {
        isEnabled: isServiceEnabled,
        filters: {
          'event^fall_score__gte:numeric': '',
          stream_ids: null,
          ...geolocationFilters,
        },
      },
    },
  }
);
